import { Store, select } from '@ngrx/store';
import * as fromCard from '../state/selectors';
var BinNumberQuery = /** @class */ (function () {
    function BinNumberQuery(store) {
        this.store = store;
    }
    Object.defineProperty(BinNumberQuery.prototype, "values", {
        get: function () {
            return this.store.pipe(select(fromCard.getBinNumber));
        },
        enumerable: true,
        configurable: true
    });
    return BinNumberQuery;
}());
export { BinNumberQuery };
